import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import formatCondition from "../utils/format-condition";
import { SectionTitle } from "../pages/VehicleInfoPage";

const RadioStyled = styled(Radio).attrs({ color: "primary" })``;

const DetailRadioLabel = ({ icon: Icon, title, subtitle }) => (
  <>
    <div style={{ display: "flex", alignItems: "center" }}>
      {Icon ? <Icon color="primary" /> : null}
      <Typography style={{ margin: "0 5px" }} variant="subtitle1">
        {title}
      </Typography>
    </div>
    <Typography variant="subtitle2">{subtitle}</Typography>
  </>
);

const ConditionRadio = ({
  name,
  value,
  onChange,
  contactURL,
  disablePoorCondition,
  ...props
}) => (
  <FormControl component="fieldset" {...props}>
    <SectionTitle component="legend">Vehicle Condition</SectionTitle>
    <RadioGroup
      aria-label="Vehicle Condition"
      name={name}
      value={value}
      onChange={onChange}
    >
      <FormControlLabel
        value="goodTradeInValue"
        control={<RadioStyled />}
        label={
          <DetailRadioLabel
            title={formatCondition("goodTradeInValue")}
            subtitle="Truly showroom condition, completely free of any mechanical or
        physical wear."
          />
        }
      />
      <FormControlLabel
        value="fairTradeInValue"
        control={<RadioStyled />}
        label={
          <DetailRadioLabel
            title={formatCondition("fairTradeInValue")}
            subtitle="Normal wear and tear. Minor paint chips or dings, interior scuffs
        and stains, etc."
          />
        }
      />
      <FormControlLabel
        value="poorTradeInValue"
        control={<RadioStyled />}
        label={
          <DetailRadioLabel
            title={formatCondition("poorTradeInValue")}
            subtitle={
              disablePoorCondition ? (
                <span>
                  <Link to={contactURL}>Contact dealer</Link> for trade in
                  estimate.
                </span>
              ) : (
                "Moderate exterior or interior wear and tear and/or mechanical concerns present."
              )
            }
          />
        }
        disabled={disablePoorCondition}
      />
    </RadioGroup>
  </FormControl>
);

export default ConditionRadio;
